import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { ColumnModel } from '../datatable/model/column.model';
import { PaginatorModel } from '@/core/domain/dto/http/page.dto';
import { LazyLoadEvent } from 'primeng/api';
import { Popover } from 'primeng/popover';
import { OverlayDatatableShowModel } from './model/overlay-datatable-show.model';
import { ROWS_PER_PAGE_TABLE_DEFAULT } from '@/core/utils/constants';

@Component({
  selector: 'app-overlay-datatable',
  templateUrl: './overlay-datatable.component.html',
  styleUrl: './overlay-datatable.component.scss',
  standalone: false,
})
export class OverlayDatatableComponent {

  // Chields
  @ViewChild("overlay") overlay: Popover;

  // Contents Templates
  @ContentChild("contentColumnActionsOverlay") contentColumnActionsOverlay: TemplateRef<any>;

  // Properties
  @Input("items") items: Array<any> = [];
  @Input("columns") columns: Array<ColumnModel> = [];
  @Input("lazy") lazy: boolean = false;
  @Input("paginator") paginator: boolean = false;
  @Input("paginatorModel") paginatorModel: PaginatorModel = new PaginatorModel();
  @Input("captionText") captionText: string = '';
  @Input("loadingDataTable") loadingDataTable: boolean = false;
  @Input("isResetItemsSelect") isResetItemsSelect: boolean = false;
  @Input("query") query: string;
  @Input("showFilter") showFilter: boolean = false;
  @Input("showExports") showExports: boolean = false;
  @Input("selectionMode") selectionMode: string = 'none';
  // Functions
  @Input("onLoadItemsFn") onLoadItemsFn: Function;
  @Input("onFilterItemsFn") onFilterItemsFn: Function;
  @Input("selectItemsFn") selectItemsFn: Function;
  
  // Emitters
  @Output("onHide") onHide: EventEmitter<void> = new EventEmitter();

  // Inputs Via Seters
  _showPanelOverlay: boolean = false;
  rowsDataTable: number = ROWS_PER_PAGE_TABLE_DEFAULT;

  onLoadItemsAction(event: LazyLoadEvent) {
    this.rowsDataTable = event.rows || ROWS_PER_PAGE_TABLE_DEFAULT;
    if (this.onLoadItemsFn instanceof Function) {
      this.onLoadItemsFn(event);
    }
  }

  onFilterItemsAction(query?: string) {
    if (this.onFilterItemsFn instanceof Function) {
      this.onFilterItemsFn(query, this.rowsDataTable);
    }
  }

  selectItemsOnAction(items: Array<any>) {
    if (this.selectItemsFn instanceof Function) {
      this.selectItemsFn(items);
    }
  }

  onHideOnAction(event: any) {
    this.onHide.emit();
  }

  // Setters @Inputs
  @Input("showPanelOverlay") set showPanelOverlay(model: OverlayDatatableShowModel) {
    this._showPanelOverlay = model.show;
    if(this._showPanelOverlay) {
      this.overlay?.show(model.event);
    } else {
      this.overlay?.hide();
    }
  }

}
